import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { showErrors } from '@/utils/snack'
import { queryAreas } from '@/views/SchoolList/gql'
import { AreaModel } from '@/interfaces/area'
import { TypedGqlError } from '@/interfaces/error'

@Component
export default class GetAllDistricts extends Vue {
  areas: AreaModel[] = []
  provinces: AreaModel[] = []
  cities: AreaModel[] = []
  regions: AreaModel[] = []

  provinceOptions: string[] = []
  cityOptions: string[] = []
  regionOptions: string[] = []
  schoolOptions: string[] = []
  yearOptions: string[] = []
  classesOptions: string[] = []

  // 查询省
  async getProvinces () {
    try {
      const result = await this.$apollo.query({
        query: queryAreas,
        variables: {
          parentId: 1
        }
      })
      this.provinces = result.data.queryAreas
      this.provinceOptions = this.provinces.map((item) => {
        return item.name
      })
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  async getCities (provinceId: number) {
    try {
      const result = await this.$apollo.query({
        query: queryAreas,
        variables: {
          parentId: provinceId
        }
      })
      this.cities = result.data.queryAreas
      this.cityOptions = this.cities.map((item) => {
        return item.name
      })
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  async getRegions (cityId: number) {
    try {
      const result = await this.$apollo.query({
        query: queryAreas,
        variables: {
          parentId: cityId
        }
      })
      this.regions = result.data.queryAreas
      this.regionOptions = this.regions.map((item) => {
        return item.name
      })
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }
}
